import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nullPipe'
})
export class NullPipePipe implements PipeTransform {

  transform(value: [], arg:Boolean ): unknown {
    let response = [];
    value.map(
      v=>{
        if (arg&&value===null) response.push(v);
        if (!arg&&value!=null) response.push(v);
      }
    )
    return response;
  }

}
